angular.module('identity').factory('tgIdentity', function tgIdentityFactory(tgConfig, User, $http, $q) {
	var currentUser

	if (tgConfig.hasAuthenticatedUser()) {
		currentUser = new User()
		angular.extend(currentUser, tgConfig.getAuthenticatedUser())

		currentUser.isAuthorizedFor = function (role) {
			if (!this.role) {
				return false;
			}
		
			if (this.role === 'Admin') {
					return true;
			}
		
			const roleHierarchy = {
				'Admin': ['Admin', 'Owner', 'Manager', 'Member', 'Operator', 'Viewer'],
				'Owner': ['Owner', 'Manager', 'Member', 'Operator', 'Viewer'],
				'Manager': ['Manager', 'Member', 'Operator', 'Viewer'],
				'Member': ['Member', 'Operator', 'Viewer'],
				'Operator': ['Operator', 'Viewer'],
				'Viewer': ['Viewer']
			};
		
			return !!roleHierarchy[this.role]?.includes(role);
		}
	}

	return {
		currentUser: currentUser,
		reloadCurrentUserSessionData: function () {
			var dfd = $q.defer()
			$http
				.get('/reloadCurrentUserData')
				.then(function (data) {
					angular.extend(currentUser, data)
					dfd.resolve(currentUser)
				})
				.catch(function (response) {
					dfd.reject(response)
				})
			return dfd.promise
		},
	}
})
